import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "materials-tele"
}
const _hoisted_2 = { class: "materials-tele-inner" }
const _hoisted_3 = { class: "materials-tele-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "批量提审素材", -1)
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"flex-shrink":"0","font-size":"14px","padding-top":"5px"} }, "上传图片、视频文件夹：", -1)
const _hoisted_7 = { style: {"margin-top":"10px","display":"flex"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"flex-shrink":"0","font-size":"14px","padding-top":"5px"} }, "上传提审列表：", -1)
const _hoisted_9 = { style: {"font-size":"14px","margin-top":"10px"} }
const _hoisted_10 = { style: {"font-size":"14px","margin-top":"20px","font-weight":"bold"} }
const _hoisted_11 = { style: {"margin-top":"10px"} }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { style: {"color":"red","font-size":"14px","margin-top":"20px","font-weight":"bold"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { tag: "mark" }, "❗️错误信息", -1)
const _hoisted_15 = { style: {"font-size":"12px","white-space":"pre-wrap","word-break":"break-all","max-height":"200px","overflow":"auto","margin-top":"8px","border":"1px solid #eee","border-radius":"4px","padding":"4px 8px","line-height":"1.5","color":"red"} }
const _hoisted_16 = { style: {"display":"flex","gap":"10px","justify-content":"flex-end","margin-top":"20px"} }
const _hoisted_17 = {
  key: 1,
  class: "materials-tele-mini"
}
const _hoisted_18 = { class: "materials-tele-mini-inner" }
const _hoisted_19 = { style: {"padding-left":"5px"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Some contents...", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Some contents...", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "Some contents...", -1)

import ClipboardJS from 'clipboard'
import { h, ref, computed, getCurrentInstance, nextTick} from 'vue';
import request from '@/utils/request'
import { message,Modal,notification, Button } from 'ant-design-vue';
import { useStore } from 'vuex'
import UploadFolders from './UploadFolders.vue'
import {CompressOutlined, ExpandOutlined, CloseCircleOutlined} from '@ant-design/icons-vue'
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchAddMaterial',
  setup(__props) {

const router = useRouter()
const { proxy } = getCurrentInstance();

const fileList = ref([])
const files = ref([])
const loading = ref(false)
const showSuccessTips = ref(false)
const confirmUrl = ref('')

const isPreview = ref(true)
const showSubmit = ref(false)

const store = useStore()
const isOpenFloat = computed(() => store.state.isOpenFloat)
const isMinimizedFloat = computed(() => store.state.isMinimizedFloat)

const action = ref('处理中...')
const progress = ref('')
const errorLists = ref([])
const successData = ref(null)

function show() {
  files.value = []
  clearFiles()
  nextTick(() => {
    proxy.$refs.uploadFoldersRef?.resetState()
  })
}
function folders (value) {
  store.commit('setIsMinimizedFloat', value)
}
function clearFiles() {
  loading.value = false
  fileList.value = []
  confirmUrl.value = ''
  isPreview.value = true
  showSubmit.value = false
  action.value = '处理中...'
  progress.value = ''
  errorLists.value = []
  successData.value = null
}
async function handleUpload(file) {
  if (!file.file) {
      message.error("请选择文件")
      return
  }
  fileList.value = [file.file]
  loading.value = true
  request.upload(`/api/in/kol/cpe/file/upload_excel`, file.file, 'no').then((rsp: any) => {
    console.log('rsp', rsp)
    confirmUrl.value = rsp.url
    loading.value = false
    isPreview.value = true
    showSubmit.value = false
  }).catch(() => loading.value = false)
  
}
function handlePreview() {

  action.value = '处理中...'
  progress.value = ''
  errorLists.value = []
  successData.value = null

  let files = proxy.$refs.uploadFoldersRef.fileList
  if(!files.length) {
    return message.error("请上传图片、视频文件夹")
  }
  if (!confirmUrl.value) return message.error("请上传excel文件")
  let images = files.map(v=> ({fileName: v.name}))
  startStreaming(images)
}
async function startStreaming (images) {
  const controller = new AbortController();
  const { signal } = controller;

  const timeoutId = setTimeout(() => {
    controller.abort(); // 中止请求
    
    loading.value = false
    isPreview.value = true
    showSubmit.value = false

    console.error("连接超时，已重置变量");
  }, 30000);
  loading.value = true
  try {
    const response = await fetch('/api/in/kol/cpe/admin/material_approval/prepare_batch_add_material2', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Accept': 'text/event-stream', },
      // dataType:"text/event-stream",
      body: JSON.stringify({excelFileUrl: confirmUrl.value, imageFileList: images}),
      signal,
    });
    console.log('response', response)
    // 2. 一旦服务器响应了（Header已收到），就清除定时器
    clearTimeout(timeoutId);

    if (!response.body) return;

    console.log('response.body', response.body)
    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    // 缓存残缺的分片（防止一个 JSON 被横跨两个 chunk 切断）
    let leftovers = ''; 

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      console.log(9999, value, done)
      // 将二进制转为文本，并加上上次剩下的残余部分
      const chunk = leftovers + decoder.decode(value, { stream: true });
      
      // 按换行符分割
      const lines = chunk.split('\n');
      
      // 最后一行可能是不完整的，先存起来下次拼上
      leftovers = lines.pop() || '';

      for (const line of lines) {
        const trimmedLine = line.trim();
        
        // 关键：只处理 data: 开头的行
        if (trimmedLine.startsWith('data:')) {
          // 提取 data: 后面的内容
          const dataContent = trimmedLine.replace(/^data:\s*/, '');
          
          if (dataContent === '[DONE]') {
            console.log("传输结束");
            break;
          }

          try {
            // 如果 data 后面是 JSON 字符串，解析它
            const parsed = JSON.parse(dataContent);
            console.log("拿到纯数据:", parsed);
            action.value = parsed.action
            if (parsed.action=='结束') {
              loading.value = false
              isPreview.value = false
              errorLists.value = parsed.error.split('\n').filter(Boolean)
              if (errorLists.value.length) {
                showSubmit.value = false
              }
              if (parsed.error && parsed.message=='失败') {
                isPreview.value = true
                showSubmit.value = false
              }
              if (parsed.data && parsed.message=='成功') {
                successData.value = parsed.data
                showSubmit.value = true
              }
              break
            }
            if (parsed.action=='进行中') {
              progress.value = parsed.progress.text
              if (parsed.error) {
                errorLists.value.push(parsed.error) 
              }
            }
            // 假设你要的数据在 content 字段里
            // yourRef.value += parsed.content; 
          } catch (e) {
            // 如果 data 后面只是普通字符串而非 JSON
            console.log("纯文本数据:", dataContent);
            // yourRef.value += dataContent;
          }
        }
      }
    }
  } catch(err) {
    console.log(err)
    message.error("连接超时，请检查。")
    loading.value = false
    isPreview.value = true
    showSubmit.value = false
  }
}
function startUpload() {
  // console.log(successData.value)
  // if (!successData.value) {
  //   return message.error("暂无可提交的信息")
  // }
  loading.value=true
  proxy.$refs.uploadFoldersRef.initOSSClient()
}
function handleOk() {
  let errorMessage = errorLists.value.length
  let title = errorMessage ? '❗️存在错误信息' : '是否确认提交?'
  Modal.confirm({
    content: () => title,
    onOk: () => {
      loading.value = true
      let successes = proxy.$refs.uploadFoldersRef.successFiles
      let images = successes.map(v=> ({fileName: v.fileName, url: v.url}))
      request.post(`/api/in/kol/cpe/admin/material_approval/batch_add_material2`, {data: successData.value, excelFileName:fileList.value[0].name, excelFileUrl: confirmUrl.value, imageFileList: images}, '操作成功', {
        
      }).then((rsp) => {
        console.log(1111, rsp);
        if (rsp.code==200) {
          onCancle()
          onTip()
          store.commit('setIsmaterialSuccess', true)
        } 
        
        loading.value = false
      }).catch(()=>loading.value = false)
    },
    onCancel() {
      loading.value=false
      Modal.destroyAll();
    },
  });
  
}
function onCancle() {
  show()
  folders(false)
  store.commit('setIsOpenFloat', false)

}
const handleViewTemp = async () => {

  try {
    const response = await fetch('/templates/template-material.xlsx');
    if (!response.ok) throw new Error('文件不存在');
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = '批量提审素材.xlsx';
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // 
  }
}

function onTip() {
  const key = `open${Date.now()}`;
  notification.open({
    message: '提示',
    description:'后台任务处理中, 请前往任务中心查看进度',
    btn: () =>
      h(
        Button,
        {
          type: 'primary',
          size: 'small',
          onClick: () => {
            router.push({name:'TaskCenter'})
            if (!isMinimizedFloat.value) {
              folders(true)
            }
            notification.close(key)
          },
        },
        { default: () => '立即查看' },
      ),
    key,
    onClose: close,
  });
}

const copyMessage = (text) => {
  new ClipboardJS('.copy-button', {
    text: function (trigger) {
      return errorLists.value.join('\n')
    },
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isOpenFloat.value&&!isMinimizedFloat.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(CompressOutlined), {
                style: {"cursor":"pointer"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (folders(true)))
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(UploadFolders, {
                ref: "uploadFoldersRef",
                onFinished: handleOk
              }, null, 512)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", null, [
                _createVNode(_component_a_upload, {
                  "file-list": fileList.value,
                  "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event)),
                  name: "avatar",
                  "show-upload-list": false,
                  customRequest: handleUpload
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(fileList.value.length?'重新上传文件':'上传文件'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"20px"},
                  onClick: handleViewTemp
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载模版")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("span", null, _toDisplayString(item.name), 1),
                      _createVNode(_unref(CloseCircleOutlined), {
                        style: {"cursor":"pointer","margin-left":"20px","color":"blue","font-weight":"bold"},
                        onClick: clearFiles
                      })
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(progress.value), 1),
            _createElementVNode("div", _hoisted_11, [
              (errorLists.value && errorLists.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_a_button, {
                        style: {"padding-left":"20px"},
                        onClick: copyMessage,
                        class: "copy-button",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("复制")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorLists.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_a_button, {
                type: "primary",
                loading: loading.value,
                onClick: handlePreview
              }, {
                default: _withCtx(() => [
                  _createTextVNode("生成预览数据")
                ]),
                _: 1
              }, 8, ["loading"]),
              (showSubmit.value)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    loading: loading.value,
                    onClick: startUpload
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确认提交")
                    ]),
                    _: 1
                  }, 8, ["loading"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                key: "back",
                onClick: onCancle
              }, {
                default: _withCtx(() => [
                  _createTextVNode("关闭")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (isOpenFloat.value&&isMinimizedFloat.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", null, [
              (action.value)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "green"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(),
              _createElementVNode("span", _hoisted_19, _toDisplayString(progress.value), 1)
            ]),
            _createVNode(_unref(ExpandOutlined), {
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (folders(false)))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      open: showSuccessTips.value,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((showSuccessTips).value = $event)),
      title: "Basic Modal",
      onOk: handleOk
    }, {
      default: _withCtx(() => [
        _hoisted_20,
        _hoisted_21,
        _hoisted_22
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})